import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { FlaggedIngredient } from "./ingredient-rules";

export type IngredientAnalysisRow = {
  product_id: string;
  source: string;
  source_url: string | null;
  ingredients_text: string;
  flagged: FlaggedIngredient[];
  tags: string[];
  score: number;
};

/** Πλήρης ανάλυση συστατικών ενός προϊόντος. */
export const getProductIngredients = createServerFn({ method: "GET" })
  .inputValidator((input: { productId: string }) => z.object({ productId: z.string().uuid() }).parse(input))
  .handler(async ({ data }) => {
    const { gameCouponDb } = await import("./game-coupons.server");
    const { data: row } = await gameCouponDb()
      .from("product_ingredients")
      .select("product_id, source, source_url, ingredients_text, flagged, tags, score")
      .eq("product_id", data.productId)
      .maybeSingle();
    return { analysis: (row ?? null) as IngredientAnalysisRow | null };
  });

/** Συμπαγής χάρτης id → σκορ για τα κυκλάκια στις κάρτες. */
export const listIngredientScores = createServerFn({ method: "GET" }).handler(async () => {
  const { loadIngredientScores } = await import("./ingredients.server");
  const rows = await loadIngredientScores();
  const map: Record<string, number> = {};
  for (const r of rows) map[r.product_id] = r.score;
  return { scores: map };
});
